/**
 * 链云业务线-灰度版本
 */
export const GRAY_VERSION = "3.10.0";
/**
 * 船务灰度版本
 */
export const SHIP_GRAY_VERSION = "3.10.0";
